import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';

interface DropzoneProps {
  onDrop: (acceptedFiles: File[]) => void | Promise<void>;
  photoUrl?: string;
}

const ProfilePhotoDropzone: React.FC<DropzoneProps> = ({ onDrop, photoUrl }) => {
  const [error, setError] = useState<string | null>(null);
  const defaultImage = '/images/profile/default.png';
  const MAX_FILE_SIZE = 3 * 1024 * 1024;

  const onDropAccepted = async (acceptedFiles: File[]) => {
    const file = acceptedFiles[0];
    if (!file) return;

    if (file.size > MAX_FILE_SIZE) {
      setError('El archivo supera el tamaño máximo de 3 MB.');
      return;
    }

    setError(null);
    await onDrop(acceptedFiles);
  };

  const onDropRejected = () => {
    setError('Solo se permiten imágenes JPEG, PNG o GIF de máximo 3MB.');
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDropAccepted,
    onDropRejected,
    multiple: false,
    accept: {
      'image/*': ['.jpeg', '.jpg', '.png', '.gif'],
    },
  });

  const isValidUrl = (url: string | undefined) => {
    if (!url) return false;
    return url.startsWith('http') || url.startsWith('/');
  };

  return (
    <div
      {...getRootProps()}
      style={{ textAlign: 'center', cursor: 'pointer', border: '1px dashed gray', padding: '20px' }}
    >
      <input {...getInputProps()} />
      <p>Arrastra y suelta tu foto aquí, o haz clic para seleccionar el archivo</p>

      {error && <p style={{ color: 'red' }}>{error}</p>}

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: '20px',
          width: '100%',
        }}
      >
        <div
          style={{
            width: '200px',
            height: '200px',
            borderRadius: '50%',
            overflow: 'hidden',
            border: '2px solid #ccc',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {isValidUrl(photoUrl) ? (
            <img
              src={photoUrl ?? defaultImage}
              alt="Vista previa"
              width={200}
              height={200}
              style={{ objectFit: 'cover' }}
            />
          ) : (
            <img
              src={defaultImage}
              alt="Foto por defecto"
              width={200}
              height={200}
              style={{ objectFit: 'cover' }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfilePhotoDropzone;
